/**
 * Whole Life Custom Enums
 *
 * These enums are defined here (not in generated types) to provide
 * properly named enums specific to Whole Life benefits.
 *
 * Note: While the OpenAPI spec reuses generic types like RfpVoluntaryLifeEmployeeBenefitTypeEnum
 * and RfpVisionCopayRuleType for Whole Life benefits, we define LOC-specific enums here
 * to maintain clarity and avoid sharing enums between different lines of coverage.
 */

/**
 * Employee Benefit Amount Type for Whole Life
 *
 * Describes the benefit configuration available for employee whole life benefits.
 * Maps to the API field: BaseWholeLifeBenefit.employeeBenefitAmount.type
 */
export enum RfpWholeLifeBenefitEmployeeBenefitAmountType {
  increments = "increments",
  dollarAmount = "dollarAmount",
  multipleOptions = "multipleOptions",
  salaryMultiplier = "salaryMultiplier",
}

/**
 * Dependent Benefit Type for Whole Life
 *
 * Describes the benefit configuration available for spouse and child whole life benefits.
 * Maps to the API fields:
 * - RfpWholeLifeBenefit.spouseBenefitAmount.type
 * - RfpWholeLifeBenefit.spouseBenefitMaximum.type
 * - RfpWholeLifeBenefit.childBenefitAmount.type
 * - RfpWholeLifeBenefit.childBenefitMaximum.type
 */
export enum RfpWholeLifeBenefitDependentBenefitType {
  dollarAmount = "dollarAmount",
  notIncluded = "notIncluded",
}
